import { uploadFile } from '@services/repair'
import { Spin, Upload } from 'antd'
import React from 'react'
type IFile = {
  hash: string
  path: string
  previewUrl: string
  previewUri: string
}

type Props = {
  isEdit?: boolean
  defaultFile?: Partial<IFile>
  uploadOwner: string
  uploadType?: string
  onChange?: (val?: any) => void
  children?: React.ReactNode
  onFileUploadedRender?: (file: Partial<IFile>) => React.ReactNode
}
function PhotosUpload({
  defaultFile,
  isEdit,
  onChange,
  uploadOwner,
  children = '點擊上傳',
  uploadType,
  onFileUploadedRender,
  ...props
}: Props) {
  const [loading, setLoading] = React.useState(false)
  const [file, setFile] = React.useState(defaultFile)

  const handleUpdatePics = async (file: any) => {
    setLoading(true)
    const res = await uploadFile({ file, uploadOwner, uploadType })
    const { previewUrl, path, hash, previewUri } = res.data
    setFile({ previewUrl, path, hash, previewUri })
    onChange && onChange(hash)
    setLoading(false)
  }

  return (
    <>
      <Upload
        showUploadList={false}
        customRequest={options => {
          const { file } = options
          handleUpdatePics(file)
        }}>
        {loading ? (
          <Spin />
        ) : file && onFileUploadedRender ? (
          onFileUploadedRender(file)
        ) : (
          children
        )}
      </Upload>
    </>
  )
}
export default React.memo(PhotosUpload)
